import { useEffect, useState } from 'react';
import AvailabilityBanner from './availability-banner';
import logo from 'assets/Talo-Logo.webp';
import { ROUTES } from 'config/route-configuration';
import { ChevronLeft } from 'lucide-react';
import { useAuth } from 'contexts/AuthContext';
import { fetchUserAttributes } from 'aws-amplify/auth';

const SimpleHeader = () => {
  const { user } = useAuth();
  const [firstName, setFirstName] = useState<string | null>(null);

  useEffect(() => {
    let isActive = true;
    const loadName = async () => {
      if (!user) {
        setFirstName(null);
        return;
      }
      try {
        const attrs = await fetchUserAttributes();
        if (!isActive) return;
        setFirstName(attrs.given_name ?? null);
      } catch {
        if (!isActive) return;
        setFirstName(null);
      }
    };

    loadName();
    return () => {
      isActive = false;
    };
  }, [user]);

  return (
    <header className="w-full">
      <AvailabilityBanner />
      <div className="w-full bg-white">
        <div className="mx-auto flex h-[72px] items-center justify-center px-6 text-gray-900">
          <div className="absolute left-6">
            <button
              type="button"
              onClick={() => window.history.back()}
              aria-label="Go back"
              className="text-talo-dark-green"
            >
              <ChevronLeft size={28} />
            </button>
          </div>
          <a href={ROUTES.HOME} aria-label="Talo home">
            <img src={logo} alt="Talo logo" className="h-10 w-auto" />
          </a>
          {firstName && <div className="absolute right-6 text-sm font-semibold text-brand-black">Hi, {firstName}</div>}
        </div>
      </div>
    </header>
  );
};

export default SimpleHeader;
